import React from "react";
import {IconButton} from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';

type SidebarButtonProps = {
    open: boolean,
    setOpen: (open) => void
};

export const SidebarButton: React.FC<SidebarButtonProps> = ({open, setOpen}) => {

    return (<div>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="end"
                onClick={() => setOpen(true)}
            >
                <MenuIcon/>
            </IconButton>

        </div>
    );


};

export default SidebarButton;
